import { useEffect, useRef, useState } from "react";
import { Radio } from "lucide-react";
import { api, wsUrl } from "@/lib/api";

export default function LiveTurn({ appointment }) {
  const [status, setStatus] = useState(null);
  const wsRef = useRef(null);

  const fetchStatus = async () => {
    try {
      const { data } = await api.get(`/appointments/${appointment.id}/turn-status`);
      setStatus(data);
    } catch (e) {
      console.error("No se pudo obtener el estado del turno:", e);
    }
  };

  useEffect(() => {
    fetchStatus();
    const path = `/api/ws/queue/${appointment.doctor_id}/${encodeURIComponent(appointment.center)}/${appointment.date}`;
    let closed = false;
    try {
      const ws = new WebSocket(wsUrl(path));
      wsRef.current = ws;
      ws.onmessage = () => fetchStatus();
    } catch (e) {
      console.error("No se pudo abrir el WebSocket de turnos:", e);
    }
    const poll = setInterval(fetchStatus, 6000);
    return () => {
      closed = true;
      clearInterval(poll);
      try { wsRef.current && wsRef.current.close(); } catch { /* cierre de limpieza, se ignora */ }
    };
    // eslint-disable-next-line
  }, [appointment.id]);

  if (!status) return null;
  const arrived = status.my_status === "arrived" || status.my_status === "in_progress";

  return (
    <div className="rounded-2xl border border-sky-200 bg-sky-50/50 p-6" data-testid={`live-turn-${appointment.id}`}>
      <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-[#0284C7]">
        <Radio className="h-4 w-4 animate-pulse" /> Turno en vivo
      </div>
      <div className="mt-4 grid grid-cols-3 gap-4 text-center">
        <div>
          <div className="text-xs font-bold uppercase tracking-wider text-slate-400">Turno actual</div>
          <div className="mt-1 text-3xl font-extrabold text-[#0284C7] animate-pulse" data-testid="current-turn">
            {status.current_turn || "—"}
          </div>
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-wider text-slate-400">Tu turno</div>
          <div className="mt-1 text-3xl font-extrabold text-slate-900" data-testid="my-turn">
            {status.my_turn || "—"}
          </div>
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-wider text-slate-400">Adelante</div>
          <div className="mt-1 text-3xl font-extrabold text-slate-900" data-testid="patients-ahead">
            {arrived ? status.patients_ahead : "—"}
          </div>
        </div>
      </div>
      {status.paused && (
        <p className="mt-4 rounded-full bg-amber-50 py-1.5 text-center text-xs font-bold text-amber-600">
          La cola está en pausa
        </p>
      )}
      {!status.my_turn && (
        <p className="mt-4 text-center text-xs font-bold text-slate-400">
          Aún no has hecho check-in en recepción.
        </p>
      )}
    </div>
  );
}
